// This is what we want to return, so define it explicitly
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
type EmptyObject = {};

export const authHeader = (
  refresh: boolean,
): { Authorization: string } | EmptyObject => {
  if (refresh) {
    return localStorage.getItem("refresh_token")
      ? {
          Authorization: "Bearer " + localStorage.getItem("refresh_token"),
        }
      : {};
  }
  return localStorage.getItem("id_token")
    ? {
        Authorization: "Bearer " + localStorage.getItem("id_token"),
      }
    : {};
};
